var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgChecked = function SvgChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.364,
    height: 4.95
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".checked_svgr__a{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "checked_svgr__a",
    d: "M.354 2.474a.5.5 0 01.707 0l1.06 1.061-.707.707-1.06-1.06a.5.5 0 010-.708z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "checked_svgr__a",
    d: "M1.414 4.242l3.89-3.89a.5.5 0 01.706 0 .5.5 0 010 .708L2.475 4.596a.5.5 0 01-.707 0l-.354-.354z"
  })));
};

export default SvgChecked;